import { Button, Card, Col, Container, Form, Row, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import {
  useGetFiltersQuery,
  useUpdateFileMutation,
  useGetFilesxfiltersMutation,
  useLazyGetDocumentosAsociablesQuery,
  useLazyGetPadresTipoQuery
} from "../../libs/redux/slices/Trkgfile/trkgfileApislice";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import {
  getFiltersTkr,
  getCustomFilters,
  getFilterSeries,
  setFiltersTkr,
  getReports,
  setCustomFilters,
  getFiltsNav,
  getNumDo,
  setCliidxx,
  getCliidxx,
  getDocAnio,
} from "../../libs/redux/slices/Trkgfile/trkgfileSlice";
import { useDispatch, useSelector } from "react-redux";
import Loadingx from "../Loadingx/Loadingx";
import { useCallback, useEffect, useMemo, useState } from "react";
import Modadesc from "./Modadesc";
import Metadatx from "./Metadatx";
import Linetime from "./Linetime";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  getIsConfirm,
  setErrorMessage,
  setIsConfirm,
  setShowErrors,
  setTypeMessage,
} from "../../libs/redux/slices/Errorsxx/errorsSlice";
import Trkeditx from "./Trkeditx";
import { getinfoUser, getisLoggedIn, getpermUser } from "../../libs/redux/slices/Loginxxx/loginSlice";
import { useNavigate } from "react-router-dom";
import Modaview from "./Modaview";
import { useForm } from "react-hook-form";
import { useSendMailMutation } from '../../libs/redux/slices/Repoprog/RepoprogApiSlice';
import CryptoJS from 'crypto-js';
import Modatipx from "./Modatipx";
import Contador from "./Contador";
import Bloqpadr from "./Bloqpadr";
import Tarjetax from "./Tarjetax";
import Asociar from "./Asociar";
import {
  useLazyGetClientReportQuery,
  useLazyGetValidateUpdateDoQuery,
} from "../../libs/redux/slices/autocomxSlice/autocomxApiSlice";
import Modalerr from "../Errorsxx/Modalerr";
import { colapsarPorTradicion, tradicionDe } from "./tradicion";
import { compararHijos, compararOtros, compararPadres } from "./ordenDo";
import Tradmodl from "./Tradmodl";
import Panelvis from "./Panelvis";
import { usePuertosCol } from "./usePuertosCol";

/**
 * Logica Import PDFViewer
 * Ing. Carlos F. Castaneda M.
 * Ing. Ivan Castiblanco
 */
const PDF_TYPE = 'application/pdf';
const EML_TYPE = 'message/rfc822';
//Visores propios de GENIO: aplican los permisos de impresion y descarga del usuario
const VIEWER_ROUTES = { [PDF_TYPE]: '/visor', [EML_TYPE]: '/visoreml' };

const Trkgfile = () => {
  const { register } = useForm();
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [selectedClient, setSelectedClient] = useState(0);
  const [clientOptions, setClientOptions] = useState([]);
  const [doctipxx, setDoctipxx] = useState([]);
  const [getClientReport] = useLazyGetClientReportQuery();
  const [selectedYear, setSelectedYear] = useState(0);
  const [findValidateUpdateDo, { isLoading: isLoadValidateDel }] = useLazyGetValidateUpdateDoQuery();
  const months = Array.from({ length: 12 }, (_, i) => ({
    value: i + 1,
    label: new Date(0, i).toLocaleString('default', { month: 'long' }).toUpperCase()
  }));
  months.unshift({ value: 0, label: 'SELECCIONE' });
  const currentYear = new Date().getFullYear();
  const years = [
    { label: currentYear - 1 },
    { label: currentYear }
  ]; //Ajuste año anterior y actual
  years.unshift({ label: 'SELECCIONE' });
  const [correos, setCorreos] = useState('');
  const limpiarCampos = () => {
    setSelectedClient(0);
    setSelectedMonth(0);
    setSelectedYear(0);
    setCorreos('');
    setDoctipxx('');
  };
  const [sendMail] = useSendMailMutation();

  const generarReporte = async () => {
    if (!selectedClient || !selectedMonth || !selectedYear || !correos || (!doctipxx && doctipxx === "")) {
      alert('Todos los campos son necesarios para enviar el correo.');
      return;
    }

    const emailData = {
      CLIIDXXX: selectedClient,
      MONTHXXX: selectedMonth,
      YEARXXXX: selectedYear,
      DOCTIPXX: doctipxx,
      EMAILSXX: correos
    };

    setLoadReport(true);
    try {
      await sendMail(emailData).unwrap();
      alert('Correo enviado con éxito!');
    } catch (error) {
      console.error('Error al enviar correo:', error);
    } finally {
      setLoadReport(false); // Desactiva la animación de carga, independientemente del resultado
    }
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filters = useSelector(getFiltersTkr);
  const customFilters = useSelector(getCustomFilters);
  const seriesxFilter = useSelector(getFilterSeries);
  const filtrosNavar = useSelector(getFiltsNav);
  const reports = useSelector(getReports);
  const numDo = useSelector(getNumDo);
  const cliid = useSelector(getCliidxx);
  const docAnio = useSelector(getDocAnio);
  const { page, perPage, sorts } = customFilters;
  const [loadReport, setLoadReport] = useState(false);
  const [selAllChecked, setSelAllChecked] = useState([]);
  const [AllChecked, setAllChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [checSelc, setChecSelc] = useState([]);
  const [dataTkr, setDatatkr] = useState([]);
  const [opMetada, setOpMetada] = useState(false);
  const [metadaSelc, setMetadaSelc] = useState("");
  const [linetime, setLinetime] = useState(false);
  const [lineData, setLineData] = useState("");
  const isDelete = useSelector(getIsConfirm);
  const [dataDelete, setDataDelete] = useState(null);
  const [updateFile] = useUpdateFileMutation();
  const [modalEdit, setModalEdit] = useState(false);
  const [dataEdit, setDataEdit] = useState(null);
  const permUser = useSelector(getpermUser);
  const [permissionDelete, setPermissionDelete] = useState(false);
  const [permissionUpdate, setPermissionUpdate] = useState(false);
  const [tiposPermission, setTiposPermission] = useState(null);
  const isLoggedIn = useSelector(getisLoggedIn);
  const [metadaMaqSelc, setMetadaMaqSelc] = useState("");
  const [modalView, setModalView] = useState(false);
  const [jsonFilters, setJsonFilters] = useState("");
  const [currentImage, setCurrentImage] = useState("");
  const infoUser = useSelector(getinfoUser);
  const [isDownloadTipo, setIsDownloadTipo] = useState({});
  const [checkDownload, setCheckDownload] = useState([]);
  const [openTipoDocModal, setOpenTipoDocModal] = useState(false);
  const [tipoDocs, setTipoDocs] = useState([]);
  const [selectedTipoDoc, setSelectedTipoDoc] = useState("");
  const [jsonMeta, setJsonMeta] = useState({});
  const [getFilesxfilters] = useGetFilesxfiltersMutation();
  const [showModalError, setShowModalError] = useState(false);
  const [isLoadings, setIsLoading] = useState(false);
  const [metadaMaqExcel, setMetadaMaqExcel] = useState("");
  const [permissionInvalidate, setPermissionInvalidate] = useState(false);
  const [dataInvalidate, setDataInvalidate] = useState(null);
  // Token de CIMA leido directo del store: el selector getTokenCima del slice
  // apunta a state.cima, pero la llave real del store es cimaxxxx.
  const tokenCima = useSelector((state) => state.cimaxxxx?.token);
  //Codigo - nombre de los metadatos de puertos (f_getPuertoCol). No toca la
  //consulta de documentos: los nombres se piden una vez y se cruzan aqui
  const { describirMetadato, etiquetasPuerto } = usePuertosCol(dataTkr);
  //Panel lateral derecho con el visor del documento
  const [panelVisor, setPanelVisor] = useState({ show: false, titulo: "", src: "" });
  //Modal con las tradiciones documentales de jerarquia menor
  const [versionesSelc, setVersionesSelc] = useState(null);
  //Secciones plegables de Otros Documentos y Documentos Invalidados
  const [otrosPlegado, setOtrosPlegado] = useState(false);
  const [invalidadosPlegado, setInvalidadosPlegado] = useState(false);


  useEffect(() => {
    if (!loadReport) {
      setSelectedClient(0);
      setSelectedMonth(0);
      setSelectedYear(0);
      setCorreos('');
      setDoctipxx('');
    }
  }, [loadReport]);

  const handleSearch = async (query) => {
    setIsLoading(true);
    try {
      const result = await getClientReport(query).unwrap();
      const formatData = result.data.map((client) => ({
        id: client.id,
        label: client.label
      }));
      setClientOptions(formatData || []);
    } catch (error) {
      console.error("Error al obtener clientes:", error);
      setClientOptions([]);
    } finally {
      setIsLoading(false);
    }
  };
  const [serieId, setSerieId] = useState('');
  const [hasMore, setHasMore] = useState(null);

  const esConsultaDo = String(filters || "").includes("DOCNROXX");

  const [padresTipoSet, setPadresTipoSet] = useState(new Set());
  const [getPadresTipo] = useLazyGetPadresTipoQuery();
  const empConsulta = esConsultaDo && dataTkr.length > 0 ? dataTkr[0].EMPNITXX : null;
  useEffect(() => {
    if (!empConsulta) {
      setPadresTipoSet(new Set());
      return;
    }
    let vivo = true;
    getPadresTipo({ EMPNITXX: empConsulta })
      .unwrap()
      .then((resp) => {
        if (!vivo) return;
        const set = new Set(
          (resp?.data || []).map(
            (t) => `${t.EMPNITXX}|${t.AREAIDXX}|${t.SERIEIDX}|${t.TIPOIDXX}`
          )
        );
        setPadresTipoSet(set);
      })
      .catch(() => vivo && setPadresTipoSet(new Set()));
    return () => {
      vivo = false;
    };
  }, [empConsulta, getPadresTipo]);

  const indexMap = useMemo(() => {
    const mapa = new Map();
    dataTkr.forEach((row, i) => mapa.set(String(row.IDARCHXX), i));
    return mapa;
  }, [dataTkr]);

  /**
   * Jerarquia de tradicion documental: de los cargues ACTIVOS que comparten
   * cliente y documento de transporte (o numero de DO) solo queda visible el de
   * mayor jerarquia (LIBERADO > ORIGINAL > COPIA).
   */
  const vistaTradicion = useMemo(() => colapsarPorTradicion(dataTkr), [dataTkr]);

  /**
   * Documentos a pintar. Los hijos que apuntaban a un cargue oculto se
   * reapuntan al cargue visible que lo representa para no perderlos de la vista.
   */
  const docsVisibles = useMemo(() => {
    const { visibles, remap } = vistaTradicion;
    if (remap.size === 0) return visibles;
    return visibles.map((row) => {
      const padres = (row.PARENTSX || []).map(String);
      if (!padres.some((pid) => remap.has(pid))) return row;
      return {
        ...row,
        PARENTSX: Array.from(new Set(padres.map((pid) => remap.get(pid) || pid))),
      };
    });
  }, [vistaTradicion]);

  const idsVisibles = useMemo(
    () => new Set(docsVisibles.map((row) => row.IDARCHXX)),
    [docsVisibles]
  );

  const vistaDo = useMemo(() => {
    const padreIds = new Set();
    docsVisibles.forEach((row) =>
      (row.PARENTSX || []).forEach((pid) => padreIds.add(String(pid)))
    );
    const esPadreTipo = (row) =>
      padresTipoSet.has(`${row.EMPNITXX}|${row.AREAIDXX}|${row.SERIEIDX}|${row.TIPOIDXX}`);
    const claseDe = (row) => {
      if (padreIds.has(String(row.IDARCHXX)) || esPadreTipo(row)) return "PADRE";
      if ((row.PARENTSX || []).length > 0) return "HIJO";
      return "OTRO";
    };
    const claseMap = new Map();
    docsVisibles.forEach((row) => claseMap.set(String(row.IDARCHXX), claseDe(row)));

    let padresN = 0, hijosN = 0, otrosN = 0;
    claseMap.forEach((clase) => {
      if (clase === "PADRE") padresN++;
      else if (clase === "HIJO") hijosN++;
      else otrosN++;
    });

    const activos = docsVisibles.filter((row) => row.REGESTXX !== "INVALIDO");
    const invalidados = docsVisibles.filter((row) => row.REGESTXX === "INVALIDO");
    //Orden por familia documental, igual a la lista de chequeo de CIMA (ver ordenDo.js)
    const padres = activos
      .filter((row) => claseMap.get(String(row.IDARCHXX)) === "PADRE")
      .sort(compararPadres);
    const idsPadres = new Set(padres.map((row) => String(row.IDARCHXX)));
    //Los hijos cuyo padre no esta entre los activos del DO van con los otros
    //documentos; antes no se pintaban en ningun bloque
    const otros = activos
      .filter((row) => {
        const clase = claseMap.get(String(row.IDARCHXX));
        if (clase === "OTRO") return true;
        return clase === "HIJO" && !(row.PARENTSX || []).some((pid) => idsPadres.has(String(pid)));
      })
      .sort(compararOtros);
    const padresConHijos = padres.map((padre) => ({
      padre,
      hijos: activos
        .filter(
          (hijo) =>
            claseMap.get(String(hijo.IDARCHXX)) === "HIJO" &&
            (hijo.PARENTSX || []).map(String).includes(String(padre.IDARCHXX))
        )
        .sort(compararHijos),
    }));

    return {
      claseMap,
      contadores: { padres: padresN, hijos: hijosN, otros: otrosN },
      padresConHijos,
      otros,
      invalidados,
    };
  }, [docsVisibles, padresTipoSet]);

  const contadoresDo = vistaDo.contadores;
  const gruposDo = vistaDo;

  const [asociarShow, setAsociarShow] = useState(false);
  const [asociarMode, setAsociarMode] = useState("hijo");
  const [asociarFixed, setAsociarFixed] = useState(null);
  const [asociarCandidates, setAsociarCandidates] = useState([]);
  const [asociarLoading, setAsociarLoading] = useState(false);
  const [getDocumentosAsociables] = useLazyGetDocumentosAsociablesQuery();

  const anioDe = (id) => String(id).substring(0, 4);
  const normDOs = (v) =>
    v == null || v === "" ? [] : (Array.isArray(v) ? v : [v]).map(String).filter((x) => x !== "");

  const onAsociarHijo = async (padre) => {
    setAsociarMode("hijo");
    setAsociarFixed(padre);
    setAsociarCandidates([]);
    setAsociarShow(true);
    try {
      const resp = await getDocumentosAsociables({
        IDARCHPA: padre?.IDARCHXX,
        CLIIDXXX: padre?.JSONMETX?.CLIIDXXX,
      }).unwrap();
      const padreId = String(padre.IDARCHXX);
      const disponibles = (resp?.data || []).filter(
        (doc) =>
          String(doc.IDARCHXX) !== padreId &&
          !(doc.PARENTSX || []).map(String).includes(padreId)
      );
      setAsociarCandidates(disponibles);
    } catch (error) {
      setAsociarCandidates([]);
    }
  };

  const onAsociarPadre = (hijo) => {
    const yaPadres = (hijo.PARENTSX || []).map(String);
    const candidatos = gruposDo.padresConHijos
      .map((g) => g.padre)
      .filter((p) => !yaPadres.includes(String(p.IDARCHXX)));
    setAsociarMode("padre");
    setAsociarFixed(hijo);
    setAsociarCandidates(candidatos);
    setAsociarShow(true);
  };

  const onConfirmAsociar = async (selectedIds) => {
    setAsociarLoading(true);
    try {
      if (asociarMode === "hijo") {
        const padre = asociarFixed;
        const padreId = String(padre.IDARCHXX);
        const padreDOs = normDOs(padre?.JSONMETX?.DOCNROXX);
        await Promise.all(
          selectedIds.map((hijoId) => {
            const doc = asociarCandidates.find((d) => String(d.IDARCHXX) === String(hijoId));
            const nuevos = Array.from(new Set([...(doc?.PARENTSX || []).map(String), padreId]));
            const jsonMet = {
              ...(doc?.JSONMETX || {}),
              DOCNROXX: Array.from(new Set([...normDOs(doc?.JSONMETX?.DOCNROXX), ...padreDOs])),
            };
            return updateFile({
              IDARCHXX: hijoId,
              PARENTSX: nuevos,
              JSONMETX: jsonMet,
              anio: anioDe(hijoId),
            }).unwrap();
          })
        );
      } else {
        const hijo = asociarFixed;
        const nuevos = Array.from(
          new Set([...(hijo.PARENTSX || []).map(String), ...selectedIds.map(String)])
        );
        await updateFile({
          IDARCHXX: hijo.IDARCHXX,
          PARENTSX: nuevos,
          anio: anioDe(hijo.IDARCHXX),
        }).unwrap();
      }
      setAsociarShow(false);
      dispatch(setCustomFilters({ ...customFilters, page: 1 }));
      dispatch(setShowErrors(true));
      dispatch(setTypeMessage("Confirmacion"));
      dispatch(setErrorMessage({ message: "Asociación realizada correctamente!" }));
    } catch (error) {
      const msg = error?.data?.errors?.message || "No se pudo realizar la asociación.";
      dispatch(setShowErrors(true));
      dispatch(setTypeMessage("Error"));
      dispatch(setErrorMessage({ message: msg }));
    } finally {
      setAsociarLoading(false);
    }
  };

  const renderCard = (row) => {
    const idx = indexMap.get(String(row.IDARCHXX));
    return (
      <Tarjetax
        row={row}
        idx={idx}
        clase={vistaDo.claseMap.get(String(row.IDARCHXX))}
        checked={selAllChecked[idx]}
        onCheck={selChecked}
        viewLine={viewLine}
        viewMetada={viewMetada}
        viewFiles={viewFiles}
        viewImages={viewImages}
        versiones={vistaTradicion.versiones.get(String(row.IDARCHXX)) || []}
        onVerVersiones={verVersiones}
        describirMetadato={describirMetadato}
      />
    );
  };

  /**
   * Abre el modal con los cargues de tradicion documental de jerarquia menor
   * @param principal - documento visible (mayor jerarquia)
   * @param versiones - cargues de jerarquia menor
   */
  const verVersiones = (principal, versiones) => {
    setVersionesSelc({ principal, versiones });
  };

  const { data, isLoading, isFetching } = useGetFiltersQuery({
    filters,
    docAnio,
    reports: reports,
    page,
    per_page: perPage,
    sorts,
  });
  useEffect(() => {
    if (data && data?.data?.length > 0 && !reports) {
      const dataTkring = data.data.map((row) => {
        if (row.JSONMETX?.CLIIDXXX) {
          dispatch(setCliidxx(row.JSONMETX.CLIIDXXX))
        }
        switch (row.TYPEXXXX) {
          case "application/pdf":
            return {
              ...row,
              imgfilex:
                row.REGESTXX === "INVALIDO"
                  ? "images/Icon-PDF-invalid.png"
                  : "images/Icon-PDF.png"
            };
          case "image/png":
          case "image/jpeg":
          case "image/jpg":
            let nomFile = row.PATHFILX.split("/").at(-1);
            let fileprev = nomFile.split(".").at(0) + `-prev.${nomFile.split(".").at(1)}`;
            let imagePrev = row.DOCDURLX.replace(nomFile, fileprev);
            return {
              ...row, imgfilex:
                row.REGESTXX === "INVALIDO"
                  ? "images/file-earmark-image-invalid.png"
                  : "images/file-earmark-image.svg", IMGPREVX: imagePrev
            };
          case "text/xml":
          case "application/vnd.ms-excel":
          case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            return {
              ...row, imgfilex:
                row.REGESTXX === "INVALIDO"
                  ? "images/icon-excel-invalid.png"
                  : "images/icon-excel.png"
            };
          case "docx":
            return {
              ...row, imgfilex:
                row.REGESTXX === "INVALIDO"
                  ? "images/icon-microsoft-word-invalid.png"
                  : "mages/icon-microsoft-word.png"
            };
          case "video/mp4":
          case "audio/mpeg":
            return {
              ...row, imgfilex:
                row.REGESTXX === "INVALIDO"
                  ? "images/file-video-invalid.png"
                  : "images/file-video.svg"
            };
          case EML_TYPE:
            return {
              ...row, imgfilex:
                row.REGESTXX === "INVALIDO"
                  ? "images/filetype-eml-invalid.svg"
                  : "images/filetype-eml.svg"
            };
          case "text/plain":
            return { ...row, imgfilex: "images/filetype-txt.svg" };
          default:
            return {
              ...row, imgfilex:
                row.REGESTXX === "INVALIDO"
                  ? "images/default-ext-invalid.png"
                  : "images/default-ext.svg"
            };
        }
      });
      const dataarr = data.data.map((rows, key) => {
        return (key = false);
      });
      setSelAllChecked(dataarr);
      //Validacion AREA 116
      const dataFilter = dataTkring.filter((row) => {
        let retorno = true;
        if (row.AREAIDXX === 116 && infoUser.GRUPIDXX !== "223") {
          retorno = validateExpiredDocuments(row);
        }
        return retorno;
      });
      if (data.meta.current_page > 1) {
        setDatatkr((prevdata) => prevdata.concat(dataFilter));
      } else {
        setDatatkr(dataFilter);
      }
      setChecSelc([]);
      setCheckDownload([]);
      setAllChecked(false);
      if (isLoggedIn) {
        navigate("/home")
      }
      setShowModalError(false);
    } else {
      setDatatkr([]);
    }
    if (data?.data?.length === 0) {
      setShowModalError(true);
    }
    // eslint-disable-next-line
  }, [data, dispatch]);

  const selectMet = (xMeta) => {
    const page = 1;
    dispatch(setCustomFilters({ ...customFilters, page }));
    let finalfilts = "";
    if (parseInt(xMeta) === 0) {
      finalfilts = filtrosNavar;
    } else if (parseInt(xMeta) === 1) {
      if (cliid !== "" && numDo !== "") {
        finalfilts = `filters[REGESTXX][IN]=ACTIVO,INVALIDO`;
        finalfilts += `&DOCNROXX=${numDo}&`;
        finalfilts += `bClient=true`;
      }
    } else {
      if (filtrosNavar.includes("SERIEIDX")) {
        const splitfilts = filtrosNavar.split("&");
        let filts = [];
        splitfilts.forEach((row) => {
          if (row.includes("SERIEIDX")) {
            filts.push(`filters[SERIEIDX]=${xMeta}`);
          } else if (!row.includes("TIPOIDXX[IN]")) {
            filts.push(row);
          }
        });
        filts.forEach((elem) => {
          finalfilts += elem + "&";
        });
        finalfilts = finalfilts.slice(0, -1);
      } else {
        finalfilts = `${filtrosNavar}&filters[SERIEIDX]=${xMeta}`;
      }
    }
    dispatch(setFiltersTkr(finalfilts));
    if (numDo) {
      setSerieId(xMeta);
      setHasMore(null);
    }
  };
  const selChecked = (xKey, e) => {
    let arrchck = [];
    setAllChecked(false);
    const valArr = selAllChecked.map((rows, key) => {
      if (xKey === key) {
        return (key = !rows);
      } else {
        return (key = rows);
      }
    });
    if (checSelc.length > 0) {
      arrchck = checSelc.filter((itm) => {
        return itm.toString() !== e.target.value;
      });
      if (e.target.checked) {
        arrchck.push(Number(e.target.value));
      }
    } else {
      arrchck.push(Number(e.target.value));
    }
    if (arrchck.length === 1) {
      permissionUser(arrchck[0]);
    }
    const filterDownload = arrchck.filter((element) => {
      const documents = dataTkr.filter((item) => item.IDARCHXX === element);
      const row = documents[0] ?? {};
      return isDownloadTipo[row.TIPOIDXX];
    });
    if (arrchck.length === filterDownload.length) {
      setCheckDownload(filterDownload);
    } else {
      setCheckDownload([]);
    }
    setChecSelc(arrchck);
    setSelAllChecked(valArr);
  };
  const selAllCheck = () => {
    if (checSelc.length > 0) {
      setChecSelc([]);
    }
    const band = !AllChecked;
    setAllChecked(band);
    let nuevosSeleccionados = [];
    let paraDescargar = [];
    const dataarr = dataTkr.map((row) => {
      //Los cargues ocultos por jerarquia de tradicion documental no se marcan
      const esValidoYActivo = band && row.REGESTXX === "ACTIVO" && idsVisibles.has(row.IDARCHXX);

      if (esValidoYActivo) {
        nuevosSeleccionados.push(row.IDARCHXX);
        if (isDownloadTipo[row.TIPOIDXX]) {
          paraDescargar.push(row.IDARCHXX);
        }
      }
      return esValidoYActivo;
    });
    setSelAllChecked(dataarr);
    setChecSelc(nuevosSeleccionados);
    setCheckDownload(paraDescargar);
  };
  const downloadSelect = () => {
    setOpenModal(true);
  };
  const tipoDocu = async () => {
    let filts = `filters[JSONMETX][->][DOCNROXX]=${numDo}&filters[REGESTXX][IN]=ACTIVO,INVALIDO&per_page=16&page=1&reports=false&environment=GESTOR&groups=TIPOIDXX`;
    if (numDo && serieId && parseInt(serieId) !== 0) {
      filts += `&filters[SERIEIDX]=${serieId}`
    }
    await getFilesxfilters({ filters: filts }, { preferCacheValue: false })
      .unwrap()
      .then((response) => {
        if (response.data.length > 0) {
          const tiposDocs = response.data.map(item => ({
            TIPOIDXX: item.TIPOIDXX,
            TIPODESX: item.TIPODESX,
            EMPNITXX: item.EMPNITXX,
            AREAIDXX: item.AREAIDXX,
            SERIEIDX: item.SERIEIDX
          }));
          setTipoDocs(tiposDocs);
        }
      });
    setOpenTipoDocModal(true);
  };

  useEffect(() => {
    setJsonMeta({});
  }, [selectedTipoDoc]);

  const filtrarDocs = async () => {
    let filts = "";
    if (selectedTipoDoc) {
      filts += `filters[TIPOIDXX]=${selectedTipoDoc}&`
    }
    if (Object.entries(jsonMeta).length > 0) {
      for (let val in jsonMeta) {
        if (jsonMeta[val] !== "") {
          filts += `filters[JSONMETX][->][${val}]=${jsonMeta[val]}&`
        }
      }
    }
    if (filts !== "") {
      filts += `filters[JSONMETX][->][DOCNROXX]=${numDo}&filters[REGESTXX][IN]=ACTIVO,INVALIDO&per_page=16&page=1&reports=false&environment=GESTOR&sorts=TYPEXXXX,IDARCHXX`;
    }
    await getFilesxfilters({ filters: filts }, { preferCacheValue: false })
      .unwrap()
      .then((response) => {
        const dataTkring = response.data.map((row) => {
          if (row.JSONMETX?.CLIIDXXX) {
            dispatch(setCliidxx(row.JSONMETX.CLIIDXXX))
          }
          switch (row.TYPEXXXX) {
            case "application/pdf":
              return {
                ...row,
                imgfilex:
                  row.REGESTXX === "INVALIDO"
                    ? "images/Icon-PDF-invalid.png"
                    : "images/Icon-PDF.png"
              };
            case "image/png":
            case "image/jpeg":
            case "image/jpg":
              let nomFile = row.PATHFILX.split("/").at(-1);
              let fileprev = nomFile.split(".").at(0) + `-prev.${nomFile.split(".").at(1)}`;
              let imagePrev = row.DOCDURLX.replace(nomFile, fileprev);
              return {
                ...row, imgfilex:
                  row.REGESTXX === "INVALIDO"
                    ? "images/file-earmark-image-invalid.png"
                    : "images/file-earmark-image.svg"
                , IMGPREVX: imagePrev
              };
            case "text/xml":
            case "application/vnd.ms-excel":
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
              return {
                ...row, imgfilex:
                  row.REGESTXX === "INVALIDO"
                    ? "images/icon-excel-invalid.png"
                    : "images/icon-excel.png"
              };
            case "docx":
              return {
                ...row, imgfilex:
                  row.REGESTXX === "INVALIDO"
                    ? "images/icon-microsoft-word-invalid.png"
                    : "images/icon-microsoft-word.png"
              };
            case "video/mp4":
            case "audio/mpeg":
              return {
                ...row, imgfilex:
                  row.REGESTXX === "INVALIDO"
                    ? "images/file-video-invalid.png"
                    : "images/file-video.svg"
              };
            case EML_TYPE:
              return {
                ...row, imgfilex:
                  row.REGESTXX === "INVALIDO"
                    ? "images/filetype-eml-invalid.svg"
                    : "images/filetype-eml.svg"
              };
            case "text/plain":
              return {
                ...row, imgfilex:
                  row.REGESTXX === "INVALIDO"
                    ? "images/Icon-PDF-invalid.png"
                    : "images/filetype-txt.svg"
              };
            default:
              return {
                ...row, imgfilex:
                  row.REGESTXX === "INVALIDO"
                    ? "images/Icon-PDF-invalid.png"
                    : "images/default-ext.svg"
              };
          }
        });
        const dataarr = response.data.map((rows, key) => {
          return (key = false);
        });
        setSelAllChecked(dataarr);
        //Validacion AREA 116
        const dataFilter = dataTkring.filter((row) => {
          let retorno = true;
          if (row.AREAIDXX === 116 && infoUser.GRUPIDXX !== "223") {
            retorno = validateExpiredDocuments(row);
          }
          return retorno;
        });
        if (response.meta.current_page > 1) {
          setDatatkr((prevdata) => prevdata.concat(dataFilter));
        } else {
          setDatatkr(dataFilter);
        }
        if (serieId !== 0) {
          setHasMore(response.meta.current_page < response.meta.last_page);
        }
        setOpenTipoDocModal(false);
      });
  }

  /**
   * Devuelve los permisos que el usuario tiene sobre un documento concreto,
   * recorriendo empresa -> area -> serie -> tipo dentro de permUser.
   * @param dataRow - documento
   * @returns {object} banderas del tipo documental (vacio si no hay coincidencia)
   */
  const permisosDelDocumento = (dataRow) => {
    if (!Array.isArray(permUser)) return {};
    const igual = (a, b) => String(a) === String(b);
    const empresa = permUser.find((emp) => igual(emp.EMPNITXX, dataRow.EMPNITXX));
    const area = empresa?.GEST0001?.find((a) => igual(a.AREAIDXX, dataRow.AREAIDXX));
    const serie = area?.GEST0002?.find((s) => igual(s.SERIEIDX, dataRow.SERIEIDX));
    const tipo = serie?.GEST0003?.find((t) => igual(t.TIPOIDXX, dataRow.TIPOIDXX));
    return tipo || {};
  };

  /**
   * Funcion para abrir el Visor del Documento en el panel lateral derecho.
   * Se apunta a la misma ruta /visor que usaba la ventana aparte, por lo que el
   * iframe conserva identicas acciones y permisos de descarga e impresion.
   *
   * Los permisos se calculan aqui y viajan en el payload cifrado: dentro del
   * iframe arranca otra instancia de la app y leer permUser de redux depende de
   * que redux-persist ya haya rehidratado, asi que los iconos podian no salir.
   * @param dataRow
   */
  const viewFiles = (dataRow) => {
    let urlBase = dataRow.DOCDURLX;
    const viewerRoute =
      dataRow && typeof dataRow === 'object' && 'TYPEXXXX' in dataRow ? VIEWER_ROUTES[dataRow.TYPEXXXX] : undefined;
    if (viewerRoute) {
      const permisos = permisosDelDocumento(dataRow);
      // Convertir los datos a JSON
      const jsonData = JSON.stringify({
        url: dataRow.DOCDURLX,
        pEMPNITXX: dataRow.EMPNITXX,
        pAREAIDXX: dataRow.AREAIDXX,
        pSERIEIDX: dataRow.SERIEIDX,
        pTIPOIDXX: dataRow.TIPOIDXX,
        pPRINTXXX: permisos.PRINTXXX ?? null,
        pDOWNLOAD: permisos.DOWNLOAD ?? null
      });

      const encryptedData = CryptoJS.AES.encrypt(jsonData, 'GenioVisorPDF').toString();
      urlBase = `${viewerRoute}/${encodeURIComponent(encryptedData)}?embed=1`;
    }
    // A los tipos con jerarquia se les muestra la tradicion junto al tipo
    const tradicion = tradicionDe(dataRow);
    const nombreTipo = dataRow.TIPODESX || dataRow.DOCDURLX.split('/').pop();
    setPanelVisor({
      show: true,
      titulo: tradicion ? `${nombreTipo} · ${tradicion}` : nombreTipo,
      src: urlBase,
    });
  };

  const viewMetada = (meta, metaMaq, metaExcel) => {
    setMetadaSelc(meta);
    setMetadaMaqSelc(metaMaq);
    setMetadaMaqExcel(metaExcel);
    setOpMetada(true);
  };
  const viewLine = (dataline) => {
    setLineData(dataline);
    setLinetime(true);
  };
  const prevpage = (page) => {
    dispatch(setCustomFilters({ ...customFilters, page }));
  };

  /**
   * Calcula los permisos de Editar/Eliminar/Invalidar de un documento
   * puntual. Se reutiliza tanto para la fila marcada del listado como para
   * cada cargue de jerarquia menor dentro de Tradmodl.
   * @param data - documento (necesita EMPNITXX, AREAIDXX, SERIEIDX, TIPOIDXX, JSONMETX)
   * @returns {Promise<{delete: boolean, update: boolean, invalidate: boolean, tiposPermission: array}>}
   */
  const permisosLocalesDe = (data) => {
    const perCompany = (permUser || []).filter((permission) => permission.EMPNITXX === data.EMPNITXX);
    const perArea = perCompany[0]?.GEST0001?.filter((area) => area.AREAIDXX === data.AREAIDXX) || [];
    const perSerie = perArea[0]?.GEST0002?.filter((serie) => serie.SERIEIDX === data.SERIEIDX) || [];
    const perTipo = perSerie[0]?.GEST0003?.filter((tipo) => tipo.TIPOIDXX === data.TIPOIDXX) || [];
    const tipo = perTipo[0];
    return {
      delete: tipo?.DELETEXX === "SI",
      update: tipo?.EDITXXXX === "SI",
      invalidate: tipo?.INVALIDA === "SI",
      tiposPermission: perTipo,
    };
  };

  /**
   * Consulta si la lista de chequeo del DO ya esta completa, caso en el que no
   * se debe permitir editar ni invalidar.
   *
   * Va con fetch directo y NO con cimaxxxxApiSlice a proposito: el
   * baseQueryWithLogOut de ese slice despacha signOut() ante cualquier 401, asi
   * que un 401 de esta consulta puntual cerraba la sesion completa del visor.
   * Igual que antes, si la consulta falla se permite la accion (el backend
   * vuelve a validar en la mutacion real).
   * @param data - documento
   * @returns {Promise<boolean>} true si la lista esta completa (hay que bloquear)
   */
  const listaChequeoCompleta = async (data) => {
    // DOCNROXX puede llegar como arreglo (varios DO en un mismo cargue, comun
    // en los BL): se une con comas, igual que en deleteRow.
    const docNro = Array.isArray(data?.JSONMETX?.DOCNROXX)
      ? data.JSONMETX.DOCNROXX.join(',')
      : data?.JSONMETX?.DOCNROXX;
    if (!docNro) return false;
    try {
      const respuesta = await fetch(
        `${process.env.REACT_APP_CIMA_ENDPOINT}/Registxx/Documexx/Lischeck/getIsCompleteLischeck/${encodeURIComponent(docNro)}`,
        {
          headers: {
            Accept: "application/json",
            ...(tokenCima ? { Authorization: `Bearer ${tokenCima}` } : {}),
          },
        }
      );
      if (!respuesta.ok) return false;
      const cuerpo = await respuesta.json();
      return cuerpo?.data?.message === true;
    } catch (error) {
      return false;
    }
  };

  //Validar permisos del usuario de la fila marcada en el listado
  const permissionUser = async (id) => {
    const data = dataTkr.find((item) => item.IDARCHXX === id);
    if (!data) return;
    const permisos = permisosLocalesDe(data);
    setTiposPermission(permisos.tiposPermission);
    setPermissionDelete(permisos.delete);
    // Editar e Invalidar dependen ademas de que la lista de chequeo del DO no
    // este completa; se consulta una sola vez para ambos.
    const bloqueaLista =
      permisos.update || permisos.invalidate ? await listaChequeoCompleta(data) : false;
    setPermissionUpdate(permisos.update && !bloqueaLista);
    setPermissionInvalidate(permisos.invalidate && !bloqueaLista);
  };

  /**
   * Abre el modal de edicion para un documento puntual. tiposPermission llega
   * ya calculado (de permissionUser para la fila marcada, o de
   * permisosPorFila para un cargue de jerarquia menor dentro de Tradmodl).
   */
  const editRow = (row, permisos) => {
    setTiposPermission(permisos?.tiposPermission || tiposPermission);
    setModalEdit(true);
    setDataEdit([row]);
  };
  const editSelect = () => {
    const row = dataTkr.find((item) => item.IDARCHXX === checSelc[0]);
    editRow(row, { tiposPermission });
  };

  const deleteRow = async (row) => {
    if (row?.JSONMETX?.DOCNROXX) {
      const docNumbers = Array.isArray(row.JSONMETX.DOCNROXX)
        ? row.JSONMETX.DOCNROXX.join(',')
        : row.JSONMETX.DOCNROXX;
      const response = await findValidateUpdateDo({ "DOCNROXX": docNumbers });
      if (response?.data?.data?.messageDelete) {
        dispatch(setShowErrors(true));
        dispatch(setTypeMessage("Error"));
        dispatch(setErrorMessage({ message: response?.data?.data?.messageDelete }));
        return;
      }
    }

    dispatch(setShowErrors(true));
    dispatch(setTypeMessage("Aviso"));
    dispatch(setErrorMessage({ message: "¿Esta seguro que desea eliminar este Documento?" }));
    setDataDelete({ IDARCHXX: row.IDARCHXX, REGESTXX: "INACTIVO", REGFECXX: row.REGFECXX });
  };
  const deleteSelect = () => deleteRow(dataTkr.find((item) => item.IDARCHXX === checSelc[0]));

  //Invalidar un docuemnto
  const invalidateRow = (row) => {
    dispatch(setShowErrors(true));
    dispatch(setTypeMessage("Aviso"));
    dispatch(setErrorMessage({ message: "¿Esta seguro que desea invalidar este documento?" }));
    setDataInvalidate({ IDARCHXX: row.IDARCHXX, REGESTXX: "INVALIDO", REGFECXX: row.REGFECXX });
  };
  const invalidateSelect = () => invalidateRow(dataTkr.find((item) => item.IDARCHXX === checSelc[0]));

  /**
   * Permisos de Editar/Eliminar/Invalidar de cada cargue de jerarquia menor.
   * Se resuelven de forma SINCRONA con las banderas de permUser, sin consultar
   * la lista de chequeo: hacerlo por cada fila al abrir el modal disparaba una
   * peticion por documento y, si alguna respondia 401, el visor cerraba la
   * sesion. Esa validacion se hace ahora al pulsar la accion (ver onEditar y
   * onInvalidar), que ademas es cuando realmente importa.
   */
  const permisosPorFila = useMemo(() => {
    if (!versionesSelc) return {};
    return Object.fromEntries(
      versionesSelc.versiones.map((row) => [String(row.IDARCHXX), permisosLocalesDe(row)])
    );
    // eslint-disable-next-line
  }, [versionesSelc, permUser]);

  const viewImages = (dataRow) => {
    let filts = '';
    if (Object.entries(dataRow.JSONMETX).length > 0) {
      for (let val in dataRow.JSONMETX) {
        if (val === "DOCNROXX" && typeof dataRow.JSONMETX[val] === 'object') {
          let nDocNros = dataRow.JSONMETX[val];
          for (let nDo of nDocNros) {
            filts += `filters[JSONMETX][->][${val}]=${nDo}&`
          };
        } else {
          if (dataRow.JSONMETX[val] !== "") {
            filts += `filters[JSONMETX][->][${val}]=${encodeURIComponent(dataRow.JSONMETX[val])}&`
          }
        }
      }
      filts += "filters[REGESTXX][IN]=ACTIVO,INVALIDO&filters[TYPEXXXX][IN]=image/png,image/jpg,image/jpeg";
    }
    setJsonFilters(filts)
    setModalView(true);
    setCurrentImage(dataRow.DOCDURLX);
    setDataEdit(dataRow);
  };

  useEffect(() => {
    if (isDelete && dataDelete) {
      // REGFECXX viaja en dataDelete: los cargues de jerarquia menor
      // (abiertos desde Tradmodl) no estan en dataTkr, asi que no se puede
      // volver a buscar el registro alli.
      updateFile({
        REGESTXX: "INACTIVO",
        IDARCHXX: dataDelete.IDARCHXX,
        anio: dataDelete.REGFECXX.split('-')[0],
      })
        .unwrap()
        .then((response) => {
          dispatch(setIsConfirm(false));
          dispatch(setShowErrors(true));
          dispatch(setErrorMessage({ message: "Documento eliminado con Exito!" }));
          dispatch(setTypeMessage("Confirmacion"));
        })
        .catch((response) => {
          if (response.data?.errors) {
            const errores = response.data?.errors;
            dispatch(setShowErrors(true));
            dispatch(setTypeMessage("Error"));
            dispatch(setErrorMessage({ message: errores }));
          } else {
            dispatch(setShowErrors(true));
            dispatch(setTypeMessage("Error"));
            dispatch(setErrorMessage({ message: "Se presentaron problemas al eliminar el Documento." }));
          }
        });
    }
    // eslint-disable-next-line
  }, [isDelete, dataDelete, updateFile, dispatch]);

  //Hook para Invalidar un docuemnto
  useEffect(() => {
    if (isDelete && dataInvalidate) {
      // REGFECXX viaja en dataInvalidate por la misma razon que en el
      // efecto de eliminar: no siempre esta en dataTkr.
      updateFile({
        REGESTXX: dataInvalidate.REGESTXX,
        IDARCHXX: dataInvalidate.IDARCHXX,
        anio: dataInvalidate.REGFECXX.split('-')[0],
      })
        .unwrap()
        .then((response) => {
          dispatch(setIsConfirm(false));
          setDataInvalidate(null);
          dispatch(setShowErrors(true));
          dispatch(setErrorMessage({ message: "Documento Invalidado con Éxito!" }));
          dispatch(setTypeMessage("Confirmacion"));
        })
        .catch((response) => {
          dispatch(setIsConfirm(false));
          setDataInvalidate(null);
          const errorMsg = response.data?.errors || "Se presentaron problemas al invalidar el Documento.";
          dispatch(setShowErrors(true));
          dispatch(setTypeMessage("Error"));
          dispatch(setErrorMessage({ message: errorMsg }));
        });
    }
  }, [isDelete, dataInvalidate, updateFile, dispatch]);

  /**
   * Funcion para validar si un documento esta vigente
   * @returns Boolean
   */
  const validateExpiredDocuments = (row) => {
    const FECINICI = new Date();
    const FECHAFIN = row.JSONMETX["FECHAFIN"] ? new Date(`${row.JSONMETX["FECHAFIN"]}T23:59:00`) : FECINICI;
    return FECHAFIN >= FECINICI;
  }

  //Funcion para validar permisos de descarga
  const validatePermissionDownload = useCallback(() => {
    if (infoUser) {
      const { USERPERM = [] } = infoUser;
      let downloadTipo = {};
      USERPERM.forEach(element => {
        const { GEST0001 } = element;
        //Filtro por areas
        GEST0001.forEach(areas => {
          const { GEST0002 } = areas;
          //Filtro por series
          GEST0002.forEach(series => {
            const { GEST0003 } = series;
            //Filtro por tipos
            GEST0003.forEach(tipos => {
              downloadTipo = { ...downloadTipo, [tipos.TIPOIDXX]: tipos?.DOWNLOAD === "SI" };
            });
          });
        });
      });
      setIsDownloadTipo(downloadTipo);
    }
  }, [infoUser]);

  //Hook para marcar los documentos que el usuario tiene para la descarga
  useEffect(() => {
    validatePermissionDownload();
  }, [validatePermissionDownload]);

  console.log(reports)

  return (
    <>
      <Container>
        {isLoading ? (
          <Loadingx />
        ) : (
          <Container fluid>
            {/* Encabezado fijo: series y DO siguen visibles al bajar en el listado */}
            <div className="tk-encabezado">
              <Row>
                <ToggleButtonGroup type="radio" name="options">
                  {seriesxFilter.length > 0 && !reports
                    ? seriesxFilter.map((row, key) => {
                      return (
                        <ToggleButton
                          key={key}
                          variant="dark"
                          id={`${row.SERIEIDX}`}
                          value={row.SERIEIDX}
                          onChange={(e) => selectMet(e.target.value)}
                        >
                          {row.SERIEDES}
                        </ToggleButton>
                      );
                    })
                    : reports && <ToggleButton variant="dark">{seriesxFilter}</ToggleButton>}
                </ToggleButtonGroup>
              </Row>
              {
                String(filters || "").includes("DOCNROXX") ? (
                  <Row className="mt-3">
                    <Col>
                      <Contador numDo={numDo} counts={contadoresDo} onFiltroTipo={() => tipoDocu()} />
                    </Col>
                  </Row>
                ) : numDo !== "" ? (
                  <Row className="mt-3">
                    <Col className="d-flex justify-content-center">
                      <h3>NUMERO DO: {numDo}</h3>
                    </Col>
                  </Row>
                ) : ""
              }
            </div>
            {checSelc.length > 0 ? (
              <>
                <Row>
                  {checkDownload.length > 1 && (
                    <Col sm={8} md={4} lg={3}>
                      <Button className="btn-yellow btn-accion m-2" onClick={() => downloadSelect()}>
                        <i className="bi bi-download"> Descargar Seleccionados</i>
                      </Button>
                    </Col>
                  )}
                  {checSelc.length === 1 && (
                    <>
                      {permissionUpdate && (
                        <Col sm={8} md={4} lg={3}>
                          <Button className="btn-yellow btn-accion m-2" onClick={() => editSelect()}>
                            <i className="bi bi-pencil"> Editar</i>
                          </Button>
                        </Col>
                      )}
                      {permissionDelete && (
                        <Col sm={8} md={4} lg={3}>
                          <Button className="btn-yellow btn-accion m-2" onClick={() => deleteSelect()}>
                            {isLoadValidateDel ? (
                              <i className="spinner-border spinner-border-sm" role="status"></i>
                            ) : (
                              <i className="bi bi-trash"> Eliminar</i>
                            )}
                          </Button>
                        </Col>
                      )}
                      {permissionInvalidate && (
                        <Col sm={8} md={4} lg={3}>
                          <Button className="btn-yellow btn-accion m-2" onClick={() => invalidateSelect()}>
                            {isLoadValidateDel ? (
                              <i className="spinner-border spinner-border-sm" role="status"></i>
                            ) : (
                              <i className="bi bi-trash"> Invalidar</i>
                            )}
                          </Button>
                        </Col>
                      )}
                    </>
                  )}
                </Row>
                <br></br>
              </>
            ) : (
              ""
            )}
            {reports && (
              <>
                <Row>
                  <Col>
                    {loadReport ? (
                      <>
                        <Button className="btn-yellow m-2">
                          <i className="spinner-border spinner-border-sm" role="status"></i> Enviando Correo...
                        </Button>
                      </>
                    ) : (
                      <>
                        <Col>
                          <Row>
                            <Col sm={12} md={12} lg={4}>
                              <Form.Label>Cliente</Form.Label>
                              <AsyncTypeahead
                                id="client-typeahead"
                                isLoading={isLoadings}
                                onSearch={handleSearch}
                                options={clientOptions}
                                defaultSelected={""}
                                labelKey="label"
                                placeholder="Buscar cliente..."
                                minLength={3}
                                onChange={(selected) => {
                                  if (selected.length > 0) {
                                    setSelectedClient(selected[0]["id"]);
                                  } else {
                                    setSelectedClient("");
                                  }
                                }}
                                filterBy={["label", "id"]}
                              />
                            </Col>
                            <Col sm={12} md={12} lg={4}>
                              <Form.Label>Mes</Form.Label>
                              <Form.Select
                                {...register("MONTHXXX")}
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.target.value)}
                              >
                                {months.map((month) => (
                                  <option key={month.value} value={month.value}>
                                    {month.label}
                                  </option>
                                ))}
                              </Form.Select>
                            </Col>
                            <Col sm={12} md={12} lg={4}>
                              <Form.Label>Año</Form.Label>
                              <Form.Select
                                {...register("YEARXXXX")}
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(e.target.value)}
                              >
                                {years.map((year) => (
                                  <option key={year.label} value={year.label}>
                                    {year.label}
                                  </option>
                                ))}
                              </Form.Select>
                            </Col>
                            <Col sm={12} md={12} lg={4}>
                              <Form.Label>Tipo de Operación</Form.Label>
                              <Form.Select
                                {...register("DOCTIPXX")}
                                value={doctipxx}
                                onChange={(e) => setDoctipxx(e.target.value)}
                              >
                                <option key={"Seleccione"} value={""}>
                                  SELECCIONE
                                </option>
                                <option key={"IMPORTACION"} value={"IMPORTACION"}>
                                  IMPORTACION
                                </option>
                                <option key={"EXPORTACION"} value={"EXPORTACION"}>
                                  EXPORTACION
                                </option>
                              </Form.Select>
                            </Col>
                          </Row>
                          <Row sm={12} md={12} lg={12}>
                            <Col sm={12} md={12} lg={12}>
                              <Form.Label>Correos a Notificar</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={3}
                                {...register("correos", { required: true })}
                                value={correos}
                                onChange={(e) => setCorreos(e.target.value)}
                              />
                            </Col>
                          </Row>
                          <Row lg={6}>
                            <Button lg={1} className="btn-yellow m-2" onClick={limpiarCampos}>Limpiar</Button>
                            <Button lg={1} className="btn-yellow m-2" onClick={generarReporte}>Generar</Button>
                          </Row>
                        </Col>
                      </>
                    )}
                  </Col>
                </Row>
                <br></br>
              </>
            )}
            {!reports && (
              <>
                <Row>
                  <Col>
                    <Form.Check label={"Seleccionar Todos"} onChange={() => selAllCheck()} checked={AllChecked} />
                  </Col>
                </Row>
                <br></br>
                <Row>
                  <Col className="d-flex justify-content-end">
                    <span>Items por Pagina: {docsVisibles.length}</span>
                  </Col>
                </Row>
              </>
            )}
            <Row>
              {(isLoading || isFetching) && page === 1 ? (
                <Loadingx />
              ) : dataTkr.length > 0 ? (
                <>
                  <InfiniteScroll
                    dataLength={dataTkr.length}
                    hasMore={(hasMore != null) ? hasMore : data.meta.current_page < data.meta.last_page}
                    next={() => prevpage(page + 1)}
                    loader={<Loadingx heigth={100} width={100} />}
                  >
                    {esConsultaDo ? (
                      <>
                        {gruposDo.padresConHijos.map(({ padre, hijos }) => (
                          <Bloqpadr
                            key={padre.IDARCHXX}
                            padre={padre}
                            hijos={hijos}
                            renderCard={renderCard}
                          />
                        ))}
                        {gruposDo.otros.length > 0 && (
                          <div className="bp-block">
                            <div className="bp-hdr bp-hdr--otros">
                              <button
                                type="button"
                                className="bp-titulo"
                                onClick={() => setOtrosPlegado((v) => !v)}
                                title={otrosPlegado ? "Desplegar seccion" : "Plegar seccion"}
                                aria-expanded={!otrosPlegado}
                              >
                                <i className={`bi ${otrosPlegado ? "bi-chevron-right" : "bi-chevron-down"} bp-plegar`}></i>
                                <span className="bp-hdr__tipo">Otros Documentos</span>
                                <span className="bp-hdr__count bp-hdr__count--otros">{gruposDo.otros.length}</span>
                              </button>
                            </div>
                            {!otrosPlegado && (
                              <div className="nv2-scroll">
                                <div className="nv2-grid">
                                  {gruposDo.otros.map((row) => (
                                    <div className="bp-hijo" key={row.IDARCHXX}>
                                      {renderCard(row)}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {gruposDo.invalidados.length > 0 && (
                          <div className="bp-block">
                            <div className="bp-hdr bp-hdr--inv">
                              <button
                                type="button"
                                className="bp-titulo"
                                onClick={() => setInvalidadosPlegado((v) => !v)}
                                title={invalidadosPlegado ? "Desplegar seccion" : "Plegar seccion"}
                                aria-expanded={!invalidadosPlegado}
                              >
                                <i className={`bi ${invalidadosPlegado ? "bi-chevron-right" : "bi-chevron-down"} bp-plegar`}></i>
                                <span className="bp-hdr__tipo">Documentos Invalidados</span>
                                <span className="bp-hdr__count bp-hdr__count--inv">{gruposDo.invalidados.length}</span>
                              </button>
                            </div>
                            {!invalidadosPlegado && (
                              <div className="nv2-scroll">
                                <div className="nv2-grid">
                                  {gruposDo.invalidados.map((row) => (
                                    <div className="bp-hijo" key={row.IDARCHXX}>
                                      {renderCard(row)}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    ) : (
                      docsVisibles.map((row, key) => {
                        //Posicion real dentro de dataTkr para conservar el estado del check
                        const idx = indexMap.get(String(row.IDARCHXX)) ?? key;
                        const versionesRow = vistaTradicion.versiones.get(String(row.IDARCHXX)) || [];
                        return (
                          <div
                            key={`pr${row.IDARCHXX}`}
                            className="p-3 col-7 col-md-4 col-lg-3 "
                            style={{ display: "inline-block" }}
                          >
                            <Card className="shadow rounded p-3" border="light" style={{ width: "15rem" }}>
                              <Container fluid>
                                <Row>
                                  <Col>
                                    {row.TYPEXXXX === "image/png" ||
                                      row.TYPEXXXX === "image/jpeg" ||
                                      row.TYPEXXXX === "image/jpg" ? (
                                      <img
                                        variant="top"
                                        src={`${process.env.REACT_APP_GESTOR_WEB}/${row.imgfilex}`}
                                        width="25"
                                        height="35"
                                        alt="imagen-files"
                                      />
                                    ) : (
                                      <img
                                        variant="top"
                                        src={`${process.env.REACT_APP_GESTOR_WEB}/${row.imgfilex}`}
                                        width="50"
                                        alt="imagen-files"
                                      />
                                    )}
                                  </Col>
                                  <Col className="d-grid justify-content-end">
                                    <Form.Check
                                      value={`${row.IDARCHXX}`}
                                      onChange={(e) => selChecked(idx, e)}
                                      checked={selAllChecked[idx]}
                                      disabled={row.REGESTXX === "INVALIDO"}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Card.Body>
                                    <Container>
                                      {row.TYPEXXXX === "image/png" ||
                                        row.TYPEXXXX === "image/jpeg" ||
                                        row.TYPEXXXX === "image/jpg" ? (
                                        <Row>
                                          <Col className="d-grid justify-content-center">
                                            <img variant="top" src={`${row.IMGPREVX}`} alt="No se encontro Prev-Imagen" />
                                          </Col>
                                        </Row>
                                      ) : (
                                        ""
                                      )}
                                      <Row key={`des${key}`}>
                                        <Col className="col-12 text-doc p-0">
                                          <strong>TIPO</strong> : {row.TIPODESX}
                                        </Col>
                                      </Row>
                                      {Object.keys(row.METADATX).map((item, key) => {
                                        // console.log("para: ", row.METADATX[item], " ", typeof row.METADATX[item]);
                                        if (key <= 3) {
                                          let typeMet = "";
                                          typeof row.METADATX[item] === "object" && row.METADATX[item] !== null
                                            ? (typeMet = row.METADATX[item].join(", "))
                                            : (typeMet = row.METADATX[item]);
                                          //los metadatos de puertos guardan solo el codigo: se muestra codigo - nombre
                                          const claveMet = Object.keys(row.METAKEYS || {}).find((clave) => row.METAKEYS[clave] === item);
                                          const descripcionMet = claveMet ? describirMetadato(claveMet, row.METADATX[item]) : null;
                                          if (descripcionMet) typeMet = descripcionMet;
                                          // Limita el texto a 30 caracteres si no está expandido
                                          typeMet = typeMet.length > 30 ? typeMet.substring(0, 30) + "..."
                                            : typeMet;
                                          return (
                                            <Row key={key}>
                                              <Col className="col-12 text-doc p-0">
                                                <strong>{item}</strong> : {typeMet}
                                              </Col>
                                            </Row>
                                          );
                                        } else {
                                          return "";
                                        }
                                      })}
                                      {/* Si cuenta con Metadatos Tipo Excel */}
                                      {row.METAEXCE && row.METAEXCE.map((meta) => {
                                        return (
                                          <Row key={meta}>
                                            <Col className="col-12 text-doc p-0">
                                              <strong>{meta.METDESXX}</strong> : {Array.isArray(meta.DOCEVALX) ? meta.DOCEVALX.slice(0, 2).join(", ") + (meta.DOCEVALX.length > 2 ? ", ..." : "") : meta.DOCEVALX}
                                            </Col>
                                          </Row>
                                        );
                                      })}
                                      <Row key={key}>
                                        <Col className="col-12 text-doc p-0">
                                          <strong>FECHA</strong> : {row.REGFECXX} / {row.REGHORXX}
                                        </Col>
                                      </Row>
                                    </Container>
                                  </Card.Body>
                                </Row>
                                <Row className="tx-acciones">
                                  <Col>
                                    <img
                                      onClick={() => viewLine(row)}
                                      src={`${process.env.REACT_APP_GESTOR_WEB}/images/icon-timeline.png`}
                                      height={30}
                                      alt="time line"
                                      style={{ cursor: "pointer" }}
                                    />
                                  </Col>
                                  <Col>
                                    <img
                                      onClick={() => viewMetada(row.METADATX, row.JSONMETX, row.METAEXCE)}
                                      variant="top"
                                      src={`${process.env.REACT_APP_GESTOR_WEB}/images/icon-info.png`}
                                      height={30}
                                      alt="info"
                                      style={{ cursor: "pointer" }}
                                    />
                                  </Col>
                                  {row.TYPEXXXX === "image/png" ||
                                    row.TYPEXXXX === "image/jpeg" ||
                                    row.TYPEXXXX === "image/jpg" ? (
                                    <Col>
                                      <img
                                        onClick={() => viewImages(row)}
                                        variant="top"
                                        src={`${process.env.REACT_APP_GESTOR_WEB}/images/icon-view.png`}
                                        height={30}
                                        alt="view"
                                        style={{ cursor: "pointer" }}
                                      />
                                    </Col>
                                  ) : (
                                    <Col>
                                      <img
                                        onClick={() => viewFiles(row)}
                                        variant="top"
                                        src={`${process.env.REACT_APP_GESTOR_WEB}/images/icon-view.png`}
                                        height={30}
                                        alt="view"
                                        style={{ cursor: "pointer" }}
                                      />
                                    </Col>
                                  )
                                  }
                                  {versionesRow.length > 0 && (
                                    <Col>
                                      <button
                                        type="button"
                                        className="tx-versiones"
                                        onClick={() => verVersiones(row, versionesRow)}
                                        title={`Ver ${versionesRow.length} tradicion${versionesRow.length > 1 ? "es" : ""} documental${versionesRow.length > 1 ? "es" : ""} de jerarquia menor`}
                                      >
                                        <i className="bi bi-layers-half"></i>
                                        <span className="tx-versiones__n">{versionesRow.length}</span>
                                      </button>
                                    </Col>
                                  )}
                                </Row>
                              </Container>
                            </Card>
                          </div>
                        );
                      })
                    )}
                  </InfiniteScroll>
                </>
              ) : (
                ""
              )}
            </Row>
            {openModal ? (
              <Modadesc openModal={openModal} setOpenModal={setOpenModal} checSelc={checkDownload} dataTkr={dataTkr} />
            ) : (
              ""
            )}
            {openTipoDocModal ? (
              <Modatipx
                openTipoDocModal={openTipoDocModal}
                setOpenTipoDocModal={setOpenTipoDocModal}
                tipoDocs={tipoDocs}
                selectedTipoDoc={selectedTipoDoc}
                setSelectedTipoDoc={setSelectedTipoDoc}
                setJsonMeta={setJsonMeta}
                jsonMeta={jsonMeta}
                filtrarDocs={filtrarDocs}
              />
            ) : (
              ""
            )}
            {opMetada ? (
              <Metadatx
                opMetada={opMetada}
                setOpMetada={setOpMetada}
                metadaSelc={metadaSelc}
                setMetadaSelc={setMetadaSelc}
                metadaMaqSelc={metadaMaqSelc}
                metadaMaqExcel={metadaMaqExcel}
                setMetadaMaqExcel={setMetadaMaqExcel}
                describirMetadato={describirMetadato}
                etiquetasPuerto={etiquetasPuerto}
              />
            ) : (
              ""
            )}
            {linetime ? (
              <Linetime linetime={linetime} setLinetime={setLinetime} lineData={lineData} setLineData={setLineData} />
            ) : (
              ""
            )}
            {modalEdit && (
              <Trkeditx
                dataEdit={dataEdit}
                modalEdit={modalEdit}
                setModalEdit={setModalEdit}
                tiposPermission={tiposPermission}
              />
            )}
            {modalView && jsonFilters && (<Modaview modalView={modalView} setModalView={setModalView} jsonFilters={jsonFilters} currentImage={currentImage} dataEdit={dataEdit} />)}
            {showModalError && (<Modalerr handleClose={setShowModalError} show={showModalError} />)}
            {asociarShow && (
              <Asociar
                show={asociarShow}
                onClose={() => setAsociarShow(false)}
                mode={asociarMode}
                fixedDoc={asociarFixed}
                candidates={asociarCandidates}
                onConfirm={onConfirmAsociar}
                loading={asociarLoading}
              />
            )}
            {versionesSelc && (
              <Tradmodl
                show={!!versionesSelc}
                onClose={() => setVersionesSelc(null)}
                principal={versionesSelc.principal}
                versiones={versionesSelc.versiones}
                viewFiles={(row) => {
                  /**
                   * Las imagenes abren en modal (Modaview), asi que se deja este
                   * modal abierto y se apilan. Los demas archivos abren en el
                   * panel lateral, que va por debajo de los modales, asi que hay
                   * que cerrar este primero.
                   * No se debe cerrar un modal y abrir otro en el mismo commit:
                   * el ModalManager de react-bootstrap desmonta el backdrop del
                   * saliente despues de que el nuevo se registro y el nuevo
                   * queda montado pero sin mostrarse.
                   */
                  if (
                    row.TYPEXXXX === "image/png" ||
                    row.TYPEXXXX === "image/jpeg" ||
                    row.TYPEXXXX === "image/jpg"
                  ) {
                    viewImages(row);
                  } else {
                    setVersionesSelc(null);
                    viewFiles(row);
                  }
                }}
                viewMetada={viewMetada}
                viewLine={viewLine}
                permisosPorFila={permisosPorFila}
                onEditar={async (row) => {
                  // La lista de chequeo se valida aqui, no al abrir el modal
                  if (await listaChequeoCompleta(row)) {
                    dispatch(setShowErrors(true));
                    dispatch(setTypeMessage("Error"));
                    dispatch(setErrorMessage({
                      message: "La lista de chequeo del DO ya esta completa: no se puede editar este documento.",
                    }));
                    return;
                  }
                  editRow(row, permisosPorFila[String(row.IDARCHXX)]);
                }}
                onEliminar={(row) => deleteRow(row)}
                onInvalidar={async (row) => {
                  if (await listaChequeoCompleta(row)) {
                    dispatch(setShowErrors(true));
                    dispatch(setTypeMessage("Error"));
                    dispatch(setErrorMessage({
                      message: "La lista de chequeo del DO ya esta completa: no se puede invalidar este documento.",
                    }));
                    return;
                  }
                  invalidateRow(row);
                }}
              />
            )}
          </Container>
        )}
      </Container>
      <Panelvis
        show={panelVisor.show}
        titulo={panelVisor.titulo}
        src={panelVisor.src}
        onClose={() => setPanelVisor({ show: false, titulo: "", src: "" })}
      />
    </>
  );
};

export default Trkgfile;
